/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Content_Options_LabelInputs */



/**
* | output |
* | --- |
* | "Content Options" |
*
* @param {Transcript_Export_Content_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_content_options_label = /** @type {((inputs?: Transcript_Export_Content_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Content_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options de contenu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhaltsoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di contenuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры содержимого")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de contenido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("内容选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンテンツオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामग्री विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de conteúdo")
	return /** @type {LocalizedString} */ ("Content Options")
});